export const categories = [
    'OLDER_ADULTS',
    'ANIMALS',
    'EDUCATION',
    'YOUNG_PEOPLE',
    'FAMILIES',
    'ENVIRONMENTAL',
    'KIDS'
  ];